import React from 'react';
import { Box, Divider, Paper, Typography } from '@mui/material';

import { Seal, UnsavedSealWithoutRegion } from '@paragon/contract-library';

import { createSeal, updateSeal } from '../../actions/sealsAndSignaturesActions';
import { sealRegionsForLoggedInUser } from '../../selectors/sealRegions';
import { UserFromSelector } from '../../selectors/users';
import { selectRegion } from '../../store/sealsAndSignaturesSlice';
import { useAppDispatch, useAppSelector } from '../hooks';
import SealInfo from './SealInfo';
import { StateDropdown } from './StateDropdown';

interface Props {
  readonly user: UserFromSelector;
}

export function SealEditor({ user }: Props) {
  const dispatch = useAppDispatch();

  const selectedRegion = useAppSelector((state) => state.sealsAndSignatures.selectedRegion);
  const sealRegions = useAppSelector(sealRegionsForLoggedInUser);

  const onSaveSeal = (record: Seal | UnsavedSealWithoutRegion) => {
    const seal = { ...record, region: selectedRegion!.name };
    if ('id' in seal) {
      dispatch(updateSeal(seal));
    } else {
      dispatch(createSeal(seal));
    }
  };

  function renderSealInfo() {
    if (selectedRegion) {
      return <SealInfo onSave={onSaveSeal} user={user} />;
    }
    return null;
  }

  return (
    <Box sx={{ minWidth: { md: 460 }, p: 1 }}>
      <Typography variant="h6">Seals</Typography>
      <Divider sx={{ mb: 4 }} />
      <Paper sx={{ p: 2, bgcolor: 'backContrast.main' }} elevation={1}>
        <StateDropdown
          active={sealRegions.sealedRegions}
          available={sealRegions.unsealedRegions}
          selected={selectedRegion}
          onRegionClicked={(payload) => {
            dispatch(selectRegion(payload));
          }}
        />
        {renderSealInfo()}
      </Paper>
    </Box>
  );
}
